import dayjs from 'dayjs'
import 'dayjs/locale/ja'

dayjs.locale('ja')

export { dayjs }

export const isWithinStartDate = (targetDate?: string, startDate?: string): boolean => startDate ? dayjs(targetDate) > dayjs(startDate).startOf('day') : true
export const isWithinEndDate = (targetDate?: string, endDate?: string): boolean => endDate ? dayjs(targetDate) <= dayjs(endDate).endOf('day') : true
